import { useEffect } from 'react';
import { useScreenStore } from '../../stores/useScreenStore';
import { useAuthStore } from '../../stores/useAuthStore';

import { isFullscreen, enterFullscreen, exitFullscreen } from '../../utils/fullscreen';

export function useFullscreen() {

  const fullscreenOn = useScreenStore(state => state.fullscreenOn);
  const user = useAuthStore(state => state.user);

  useEffect(() => {

    if (user === null) {

      if (isFullscreen()) {
        exitFullscreen();
      }

      return;
    }

    if (fullscreenOn === true) {

      enterFullscreen();

      return;
    }

    if (
      fullscreenOn === false &&
      isFullscreen()
    ) {

      exitFullscreen();

    }

  }, [user, fullscreenOn]);

}